import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["AdornmentLeft", "AdornmentRight"];
import PropTypes from 'prop-types';
import React from 'react';
import { ADORNMENT_POSITIONS } from '../../constants';
import { AdornmentLeft } from '../AdornmentLeft/AdornmentLeft';
import { AdornmentRight } from '../AdornmentRight/AdornmentRight';

/**
 * Used by `AdornedInput` to display ornamental text or icons.
 * Children given to this component will be vertically centered and
 * text color will be adjusted.
 *
 * @since 6.4.0
 */
export var Adornment = function Adornment(_ref) {
  var Left = _ref.AdornmentLeft,
    Right = _ref.AdornmentRight,
    props = _objectWithoutProperties(_ref, _excluded);
  return props.position === ADORNMENT_POSITIONS.left ? /*#__PURE__*/React.createElement(Left, _extends({
    "aria-hidden": "true"
  }, props)) : /*#__PURE__*/React.createElement(Right, _extends({
    "aria-hidden": "true"
  }, props));
};
Adornment.displayName = 'Adornment';
Adornment.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Since Adornments are considered ornamental, they use `aria-hidden="true"` by default.
   * If you believe your Adornment is providing additional context without repeating content
   * already present in the form field label, feel free to set `aria-hidden="false"`.
   */
  'aria-hidden': PropTypes.oneOf(['true', 'false']),
  /** The position of the adornment relative to the input. */
  'position': PropTypes.oneOf(Object.values(ADORNMENT_POSITIONS)),
  /**
   * `Adornment`s are only useful in the context of an `AdornedInput`
   * and must provide an `id` to link the label with the input.
   * **Note:** This is required, but it usually added directly by the
   * `AdornedInput`.
   */
  // Can't use `.isRequired` when dynamically added
  'htmlFor': PropTypes.string,
  /** The default component for `position="left"` adornments. */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  'AdornmentLeft': PropTypes.any,
  /** The default component for `position="right"` adornments. */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  'AdornmentRight': PropTypes.any
} : {};
Adornment.defaultProps = {
  'aria-hidden': 'true',
  'position': ADORNMENT_POSITIONS.left,
  AdornmentLeft: AdornmentLeft,
  AdornmentRight: AdornmentRight
};